// **Der Zwischenspeicher des Dashboards** (stale-while-revalidate): Die letzte
// Antwort liegt im Speicher des Tabs und in `sessionStorage`, damit auch ein
// Neuladen sofort etwas zeigt; die frische Antwort ersetzt sie, sobald sie da
// ist. Der Schlüssel ist derselbe, den das Abmelden löscht (app/shell.tsx) —
// er hält Mandantendaten.

import type { Dashboard } from "../../api/types";
import { DASHBOARD_CACHE_KEY } from "../../app/shell";

let memo: Dashboard | null = null;

export function readDashboardCache(): Dashboard | null {
  if (memo) return memo;
  try {
    memo = JSON.parse(sessionStorage.getItem(DASHBOARD_CACHE_KEY) ?? "null") as Dashboard | null;
  } catch {
    memo = null;
  }
  return memo;
}

export function writeDashboardCache(d: Dashboard): void {
  memo = d;
  try {
    sessionStorage.setItem(DASHBOARD_CACHE_KEY, JSON.stringify(d));
  } catch { /* voll oder privat — dann nur im Speicher */ }
}

/** Für Tests: den Speicher des Tabs vergessen (sessionStorage leert setup.ts). */
export function resetDashboardCache(): void {
  memo = null;
}
